<template>
  <div class="banner">
    <img class="w-100 banner-m" src="/images/mobile/index-banner2.png" alt="" />
  </div>
  <div class="bg-white" id="navtab">
    <ul class="nav nav-pills justify-content-between container" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="introduction-tab"
          data-toggle="tab"
          href="#introduction"
          role="tab"
          aria-controls="introduction"
          aria-selected="true"
          >企业简介</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="history-tab"
          data-toggle="tab"
          href="#history"
          role="tab"
          aria-controls="history"
          aria-selected="false"
          >发展历程</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="team-tab"
          data-toggle="tab"
          href="#team"
          role="tab"
          aria-controls="team"
          aria-selected="false"
          >团队介绍</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="activity-tab"
          data-toggle="tab"
          href="#activity"
          role="tab"
          aria-controls="activity"
          aria-selected="false"
          >团队活动</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="recruitment-tab"
          data-toggle="tab"
          href="#recruitment"
          role="tab"
          aria-controls="recruitment"
          aria-selected="false"
          >诚聘英才</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="contactus-tab"
          data-toggle="tab"
          href="#contactus"
          role="tab"
          aria-controls="contactus"
          aria-selected="false"
          >联系我们</a
        >
      </li>
    </ul>
  </div>

  <div class="tab-content">
    <div
      class="tab-pane fade show active"
      id="introduction"
      role="tabpanel"
      aria-labelledby="introduction-tab"
    >
      <!-- 企业简介 start -->
      <Content title="企业简介" class="introduction bg-white">
        <p class="corp-introduction">
          特航航空成立于1999年，具备国内、国际一二类机票代理资质，并取得国际航协颁发的相关资质，与全球100多家航空公司建立合作关系，且屡获殊荣。公司下设旅行社、影视传媒公司、企业采购综合服务公司。目前业务主要涵盖：全球机票、酒店、火车票、旅游、签证、商务用车、会务会展、企业差旅、公务出行、企业综合采购、保险等业务，能够满足个人客户、企业客户、政府客户的一站式出行活动需求。
        </p>
        <p class="corp-introduction">
          21年来特航航空已服务超过300W+会员客户，3000多家企业和政府单位，以优质服务深受广大客户好评，并获得中国企业信用评价AAA级。
        </p>
        <p class="corp-introduction">
          特航航空坚持技术优先的发展策略，旗下技术公司为国家高新技术企业，自主研发的企业差旅管理系统已被几千家企业同时使用。
        </p>
        <p class="corp-introduction">
          未来，公司将继续秉承服务至上的理念，通过不断完善技术、产品、团队，为客户提供高品质的服务。
        </p>
      </Content>

      <!-- 企业简介 end -->
    </div>
    <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
      <!-- 发展历程 start -->
      <Content title="发展历程" class="history-m" :titleStyle="{ color: '#fff' }">
        <ul>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">
              <div>2020</div>
            </div>
            <div>20周年，新的起点，新的启航</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2019</div>
            <div>GP销售全国第四，广东第一</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2018</div>
            <div>GP销售全国第五，广东第一</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2017</div>
            <div>成立自主技术团队，推出首款自己研发的APP“特易行”</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2015</div>
            <div>GP正式进入市场，成功拓展GP第一家客户</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2014</div>
            <div>截止2014底在深圳各区设立包括机场在内15个营业部</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2009</div>
            <div>销售团队成立，TMC业务独立运营</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2008</div>
            <div>荣获国际客运代理资质</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2007</div>
            <div>成立电子商务团队，进军互联网</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2006</div>
            <div>88889999正式在呼叫中心使用</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">2004</div>
            <div>销售额破亿，获各大航司嘉奖</div>
          </li>
          <li class="history-item">
            <div class="bullet"></div>
            <div class="history-year">1999</div>
            <div>特航航空成立</div>
          </li>
        </ul>
      </Content>

      <!-- 发展历程 end -->
    </div>
    <div class="tab-pane fade" id="team" role="tabpanel" aria-labelledby="team-tab">
      <!-- 团队介绍 start -->
      <Content title="团队介绍">
        <div class="team team-operation px-lg py-sm mb-md">
          <img class="team-mark" width="24" src="/images/mark.png" alt="" />
          <div class="subtitle team-operation-subtitle">技术团队</div>
          <img
            class="team-operation-photo"
            height="312"
            src="/images/operation@2x.png"
            alt="运营团队"
          />
          <div>
            <div class="subtitle team-desc-title" style="margin-bottom: 26px">团队简介</div>
            <span class="team-desc-text">
                 特航技术团队成立于2017年。团队成员不仅拥有良好的教育背景和开发能力，同时还拥有丰富的技术积累和多年行业从业经验。团队以信任、基于共识的决策、平衡务实、持续学习、坦诚相待的企业文化为基石，秉承管理的本质是激发善意和潜能的观点，致力于帮助客户实现差旅管理信息化，积极开拓在线出行市场的新天地。
            </span>
          </div>
        </div>

        <div class="team team-operation px-lg py-sm">
          <img class="team-mark" width="24" src="/images/mark.png" alt="" />
          <div class="subtitle team-operation-subtitle">运营团队</div>
          <img
            class="team-operation-photo"
            height="312"
            src="/images/operation@2x.png"
            alt="运营团队"
          />
          <div>
            <div class="subtitle team-desc-title" style="margin-bottom: 26px">团队简介</div>
            <span class="team-desc-text">
              我们有成熟、专业的运营团队（包括国内机票客服、国际机票客服、旅游签证客服等）、售后团队、财务结算团队、人力行政后勤保障团队。我们的国际机票客服团队有30余人，从事国际机票行业在5年以上人员占比超80%，客服从事从本岗位5年以上人员占比超65%，他们专业、敬业。
            </span>
          </div>
        </div>
      </Content>
      <!-- 团队介绍 end -->
    </div>
    <div class="tab-pane fade" id="activity" role="tabpanel" aria-labelledby="activity-tab">
      <!-- 团队活动start -->
      <Content title="团队活动" class="activity">
        <div id="activityCarousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#activityCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#activityCarousel" data-slide-to="1"></li>
            <li data-target="#activityCarousel" data-slide-to="2"></li>
            <li data-target="#activityCarousel" data-slide-to="3"></li>
            <li data-target="#activityCarousel" data-slide-to="4"></li>
            <li data-target="#activityCarousel" data-slide-to="5"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="/images/activities/20-1.jpg" class="d-block w-100" alt="特航20周年庆" />
              <div class="carousel-caption d-none d-md-block"></div>
            </div>
            <div class="carousel-item">
              <img src="/images/activities/20-2.jpg" class="d-block w-100" alt="特航20周年庆" />
              <div class="carousel-caption d-none d-md-block"></div>
            </div>
            <div class="carousel-item">
              <img src="/images/activities/20-3.jpg" class="d-block w-100" alt="特航20周年庆" />
              <div class="carousel-caption d-none d-md-block"></div>
            </div>
            <div class="carousel-item">
              <img src="/images/activity-1@2x.png" class="d-block w-100" alt="团队活动" />
            </div>
            <div class="carousel-item">
              <img src="/images/activity-2@2x.png" class="d-block w-100" alt="团队活动" />
              <div class="carousel-caption d-none d-md-block"></div>
            </div>
            <div class="carousel-item">
              <img src="/images/activity-4@2x.png" class="d-block w-100" alt="团队活动" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#activityCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#activityCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </Content>

      <!-- 团队活动 end -->
    </div>
    <div class="tab-pane fade" id="recruitment" role="tabpanel" aria-labelledby="recruitment-tab">
      <!-- 诚聘英才 start -->
      <a class="virtual-anchor-point" name="recruitment"></a>
      <Content title="诚聘英才">
        <div class="recruitment">
          <div class="d-flex justify-content-center">
            <div id="job-spinner" class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </Content>

      <!-- 诚聘英才 end -->
    </div>
    <div class="tab-pane fade" id="contactus" role="tabpanel" aria-labelledby="contactus-tab">
      <!-- 联系我们 start -->
      <a class="virtual-anchor-point" name="contactus"></a>
      <Content title="联系我们" :titleStyle="{ color: '#fff' }" class="contactus">
        <div class="text-center tel">
          <img class="tel-ico mr-2" src="/images/telephone.png" alt="" />
          <span>全国服务热线：0755-88889999</span>
        </div>
        <div class="tel-transfer-m">
          <div>
            <div class="col-sm transfer">转1国内机票预订</div>
            <div class="col-sm transfer">转3酒店预订</div>
            <div class="col-sm transfer">转5旅游预订</div>
            <div class="col-sm transfer">转7投诉与建议</div>
          </div>
          <div>
            <div class="col-sm transfer">转2国际机票预订</div>
            <div class="col-sm transfer">转6积分兑换</div>
            <div class="col-sm transfer">转8公务预订</div>
            <div class="col-sm transfer">转9酒类预订</div>
          </div>
        </div>
      </Content>
      <!-- 联系我们 end -->
    </div>
  </div>
</template>
<script>
import Content from '@/shared/components/content.vue'
import $ from 'jquery'
export default {
  name: 'MobileContent',
  components: { Content },
  setup() {
    const host = 'https://customer-api-gateway.teyixing.com'
    const $jobSpinner = $('#job-spinner')

    const degreeMap = {
      Graduated: '研究生',
      Undergraduate: '本科',
      PostSecondarySpecialisedCollege: '大专',
      SecondarySpecialisedSchool: '中专',
      HighSchool: '高中',
      UnLimited: '不限',
    }

    const workingDaysMap = {
      FiveDays: '5天工作制',
      FiveAndHalfDays: '5.5天工作制',
    }

    function getJobItemStr(jobInfo = {}) {
      const {
        title,
        amount,
        address,
        degree,
        workingDays,
        contactName,
        contactMail,
        contactTel,
        minSalary,
        maxSalary,
      } = jobInfo
      const description = jobInfo.description.split(/\n/)
      const requirement = jobInfo.requirement.split(/\n/)

      function getSalaryEl(minSalary, maxSalary) {
        if (minSalary && maxSalary) {
          return `<span class="text-red">${minSalary}-${maxSalary}</span> | `
        } else if (minSalary) {
          return `<span class="text-red">${minSalary}元以上</span> | `
        } else if (maxSalary) {
          return `<span class="text-red">${maxSalary}元以内</span> | `
        } else {
          return ''
        }
      }

      function getDegreeStr(degree) {
        return degree === 'UnLimited' ? '学历不限' : `${degreeMap[degree]}及以上`
      }

      return `
          <div class="job-wrapper">
            <div>
              <div class="job-title mb-2">${title}</div>
              <div class="mb-3">
                <span class="text-red">${getSalaryEl(minSalary, maxSalary)}</span>${getDegreeStr(
        degree,
      )}${workingDays ? ' | ' + workingDaysMap[workingDays] : ''}
                <span> | 需求<span class="text-red">${amount}</span>人</span>
              </div>
              <div class="job-desc-wrapper mb-3">
                <div class="job-subtitle mb-2">职位描述：</div>
                <div class="job-desc">
                  ${description.map((item) => '<div>' + item + '</div>').join('')}
                </div>
              </div>
              <div class="job-requirements mb-3">
                <div class="job-subtitle mb-2">任职要求：</div>
                <div class="job-req">
                  ${requirement.map((item) => '<div>' + item + '</div>').join('')}
                </div>
              </div>
            </div>
            <div class="job-address mb-3">
              <div class="job-subtitle mb-2">工作地址：</div>
              <div>${address}</div>
            </div>
            <div class="job-contact">
              <div class="job-tech-contact">
                <div class="job-subtitle mb-2">招聘联系方式：</div>
                <div class="job-contact-info">
                  <div class="mr-4">联系人：${contactName}</div>
                  <div class="mr-4">联系电话：<a href="tel:${contactTel}">${contactTel}</a></div>
                  <div>联系邮箱：<a href="mailto:${contactMail}">${contactMail}</a></div>
                </div>
              </div>
            </div>
          </div>
        `
    }

    function showJobSpinner() {
      $jobSpinner.show()
    }

    function hideJobSpinner() {
      $jobSpinner.hide()
    }

    function getRecruitments() {
      showJobSpinner()
      // https://www.yuque.com/docs/share/f066e679-1fe6-4145-9690-8bd5a8dfd9f9?#
      const recruitmentsApi = '/front/v1/official-website-backend/recruitment/getAll'
      const url = host + recruitmentsApi

      function jobItemMapper(jobInfo, index) {
        return index === 0
          ? getJobItemStr(jobInfo)
          : `
              <div class="job-divider"></div>
              ${getJobItemStr(jobInfo)}
            `
      }

      $.post(url)
        .done(function (res) {
          const jobList = res.data.map(jobItemMapper).join('')
          $('.recruitment').append(jobList)
        })
        .fail(function (err) {
          console.error('Request Error: ', err)
        })
        .always(function () {
          hideJobSpinner()
        })
    }

    $(document).ready(function () {
      const header = $('.header')[0].offsetHeight
      let bannerHeight = $('.banner')[0].offsetHeight
      const navtabHeight = $('#navtab').height()

      function layoutNavtab() {
        if (bannerHeight === 0) {
          bannerHeight = $('.banner')[0].offsetHeight
        }

        if ($(window).scrollTop() >= bannerHeight - navtabHeight - header - 10) {
          $('#navtab').addClass('navtab-fixed')
        } else {
          $('#navtab').removeClass('navtab-fixed')
        }
      }

      $(window).scroll(function (e) {
        layoutNavtab()
      })

      const $currentLinkItem = $('#navtab .nav-item')
      $currentLinkItem.click((e) => {
        $('#navtab .nav-pills').scrollLeft($(e.currentTarget)[0].offsetLeft - 50)
      })

      $('#navtab').on('shown.bs.tab', function (event) {
        $(window).scrollTop(bannerHeight - navtabHeight - header)
      })

      // 加载招聘列表
      getRecruitments()
    })

    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },
}
</script>

<style lang="scss" scoped>
/* tab start */
.nav-pills {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  background: #fff;
  padding: 0 15px;
}
.nav-pills::-webkit-scrollbar {
  display: none;
}

.navtab-fixed {
  position: fixed;
  top: 75px;
  z-index: 199;
  width: 100%;
  min-width: 100%;
}

.nav-pills .nav-link {
  color: #333 !important;
}

.nav-pills .nav-link.active {
  position: relative;
  background: #fff !important;
}

.nav-pills .nav-link.active::after {
  position: absolute;
  content: ' ';
  display: block;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #4b7ef6;
  left: 0;
  bottom: 0;
}

.nav-pills .nav-item {
  flex: none;
}

.nav-pills .nav-link {
  padding: 23px 24px !important;
}

@media (max-width: 768px) {
  .navtab-fixed {
    top: 64px;
  }
}
/* tab end */

.banner-about {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.corp-introduction {
  font-size: 18px;
  color: #666666;
  line-height: 32px;
  margin: 0;
}

.subtitle {
  font-size: 28px;
  font-weight: bold;
  line-height: 36px;
  margin-bottom: 40px;
}

.history {
  /* background: url("../images/history@2x.png"); */
  /* height: 959px; */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.team {
  position: relative;
  background: #ffffff;
}

.team-mark {
  position: absolute;
  top: 0;
  left: 38px;
}

.team-members {
  padding-bottom: 42px;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 48px;
}

.position {
  font-size: 22px;
  line-height: 30px;
}

.avatar {
  margin-bottom: 22px;
}

.name {
  font-size: 18px;
  line-height: 24px;
  color: #666666;
}

.team-desc-text {
  font-size: 18px;
  line-height: 32px;
  color: #666666;
}

.activity {
  background: #ffffff;
}

.history-m {
  display: none;
  background-color: #4b7ef6;
  color: #ffffff;
}

.contactus {
  background: #4b7ef6;
  color: #ffffff;
}

.contactus .title {
  color: #ffffff;
  margin-bottom: 32px;
}

.contactus .tel {
  margin-bottom: 24px;
}

.transfer {
  font-size: 14px;
  color: rgba(227, 233, 248, 1);
}

.job-title {
  font-size: 28px;
}

.job-subtitle {
  font-size: 24px;
}

.tooltip-inner {
  background-color: #ffffff;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 32px;
  padding-bottom: 32px;
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.22);
  color: #666666;
  max-width: 500px;
}

.tooltip.show {
  opacity: 1;
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #ffffff !important;
}
.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #ffffff !important;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #ffffff !important;
}
.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #ffffff !important;
}

.tooltip.top .tooltip-arrow {
  border-top-color: #ffffff;
}

.liuyin-info {
  background-color: #ffffff;
  text-align: left !important;
}

.team-members {
  display: flex;
  justify-content: space-between;
}

.team-members-m {
  display: none;
}

.team-tech {
  display: flex;
}

.team-tech-desc-wrapper {
  margin-left: 48px;
}

.tel-ico {
  width: 36px;
  height: 36px;
}

.tel-transfer-m {
  display: none;
}

.job-contact-info {
  display: flex;
}

.job-desc,
.job-req {
  padding-left: 12px;
  padding-right: 12px;
}

.job-divider {
  margin-top: 36px;
  margin-bottom: 36px;
  border: 4px solid #999999;
}

.tel-transfer {
  display: flex;
  justify-content: space-between;
}

#job-spinner {
  display: none;
}

@media (max-width: 768px) {
  .banner-about {
    height: 217px;
  }

  .history {
    background: #4b7ef6;
    height: auto;
  }

  .team {
    padding-left: 14px;
    padding-right: 14px;
    box-shadow: 0px 2px 23px 0px rgba(230, 230, 230, 1);
    border-radius: 5px;
  }

  .mb-md {
    margin-bottom: 14px;
  }

  .team-tech {
    flex-direction: column;
  }

  .team-operation-photo,
  .team-tech-logo {
    display: none;
  }

  .team-desc-title {
    display: none;
  }

  .team-operation-subtitle,
  .team-tech-subtitle {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 26px;
    margin-left: 24px;
  }

  .team-tech-desc-wrapper {
    margin-left: 0;
    font-size: 14px;
  }

  .team-mark {
    left: 14px;
    width: 12px;
  }

  .team-members {
    display: none;
  }

  .team-members-m {
    display: block;
    margin-bottom: 30px;
  }

  .avatar {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    box-shadow: 0px 2px 23px 0px rgba(230, 230, 230, 1);
    margin-right: 10px;
  }

  .comment-item {
    background-color: #ffffff;
    box-shadow: 0px 2px 23px 0px rgba(230, 230, 230, 1);
    border-radius: 4px;
    padding: 15px 20px;
  }

  .team-members-m .carousel-inner {
    width: 70%;
  }

  #commentCarousel {
    display: flex;
    justify-content: center;
  }

  .position,
  .name {
    font-size: 14px;
  }

  .liuyin-info {
    font-size: 12px;
  }

  .carousel-control-prev,
  .carousel-control-next {
    width: 32px;
    height: 32px;
    top: 24px;
    background: #ffffff;
    border-radius: 50%;
    box-shadow: -1px 13px 20px 0px rgba(240, 242, 244, 1);
    transition: all 0.3s ease-out;
  }

  .carousel-control-prev:hover,
  .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    background-color: #4b7ef6;
    box-shadow: 0px 25px 25px 0px rgba(205, 219, 255, 1);
  }

  .carousel-control-prev:hover .carousel-preview-btn,
  .carousel-control-prev:focus .carousel-preview-btn,
  .carousel-control-next:hover .carousel-next-btn,
  .carousel-control-next:focus .carousel-next-btn {
    background-image: url('/images/mobile/carousel-next-light.png');
  }

  .tel-ico {
    width: 26px;
    height: 26px;
  }

  .tel-transfer {
    display: none;
  }

  .tel-transfer-m {
    display: flex;
    justify-content: space-between;
  }

  .history {
    display: none;
  }

  .history-m {
    display: block;
  }

  .history-m .title {
    color: #ffffff;
  }

  .history-m ul {
    padding-left: 0;
    position: relative;
    margin-bottom: 0;
  }

  .history-m ul::before {
    content: ' ';
    height: calc(100% - 48px);
    width: 2px;
    background-color: #ffffff;
    opacity: 0.5;
    position: absolute;
    left: 2.5px;
    margin-top: 24px;
  }

  .history-m ul::after {
    margin-bottom: -48px;
  }

  .history-m .bullet {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #ffffff;
    margin-right: 8px;
    flex: none;
  }

  .history-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
  }

  .history-year {
    border-radius: 16px;
    margin-right: 6px;
    background-color: rgba(134, 165, 242, 1);
    padding: 1px 6px;
  }

  .job-title {
    font-size: 15px;
    font-weight: bold;
  }

  .job-wrapper,
  .job-subtitle,
  .job-desc,
  .job-responsibility-wrapper,
  .job-requirements {
    font-size: 14px;
  }

  .job-contact-info {
    display: block;
  }

  .team-desc-text {
    font-size: 14px;
  }

  .corp-introduction {
    font-size: 14px;
  }

  .introduction {
    background-color: #f5f5f5 !important;
  }
}
</style>
